// extracted by mini-css-extract-plugin
module.exports = {"container":"MCard_container__oVyBX"};